/*
  Component: Country auto-redirect
  Responsibility: switch a first-time visitor to a supported non-US market once.
  Manual country-selector submissions are treated as an explicit shopper choice and
  permanently stop this automatic behavior for the current browser profile.
*/

(function initCountryAutoRedirect() {
  const config = window.KL_COUNTRY_AUTO_REDIRECT;
  const decisionKey = 'kl_country_auto_redirect_v1';
  const manualChoiceKey = 'kl_country_manual_choice_v1';
  const geoEndpoint = config?.geoEndpoint;
  const requestTimeout = 2500;

  if (!config || config.designMode || !geoEndpoint || config.availableCountries.length < 2) return;

  function hasStorageValue(key) {
    try {
      return window.localStorage.getItem(key) === '1';
    } catch (error) {
      return false;
    }
  }

  function setStorageValue(key) {
    try {
      window.localStorage.setItem(key, '1');
    } catch (error) {
      // Private browsing can reject storage; the redirect still remains harmless.
    }
  }

  function markManualChoice(event) {
    if (event.target.closest('[data-kl-country-auto-form]')) return;
    if (event.target.closest('form[action*="/localization"]')) {
      setStorageValue(manualChoiceKey);
      setStorageValue(decisionKey);
    }
  }

  document.addEventListener('submit', markManualChoice, true);

  if (hasStorageValue(decisionKey) || hasStorageValue(manualChoiceKey)) return;
  if (config.currentCountry !== 'US') {
    setStorageValue(decisionKey);
    return;
  }

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), requestTimeout);

  fetch(geoEndpoint, {
    headers: { Accept: 'text/plain' },
    credentials: 'omit',
    signal: controller.signal,
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Country detection failed: ${response.status}`);
      return response.text();
    })
    .then((countryCode) => {
      const detectedCountry = countryCode.trim().toUpperCase();

      setStorageValue(decisionKey);

      if (detectedCountry === 'US' || !config.availableCountries.includes(detectedCountry)) return;

      const form = document.createElement('form');
      form.method = 'post';
      form.action = '/localization';
      form.dataset.klCountryAutoForm = 'true';

      const countryInput = document.createElement('input');
      countryInput.type = 'hidden';
      countryInput.name = 'country_code';
      countryInput.value = detectedCountry;

      const returnToInput = document.createElement('input');
      returnToInput.type = 'hidden';
      returnToInput.name = 'return_to';
      returnToInput.value = `${window.location.pathname}${window.location.search}`;

      form.append(countryInput, returnToInput);
      document.body.append(form);
      form.submit();
    })
    .catch(() => {
      setStorageValue(decisionKey);
    })
    .finally(() => {
      window.clearTimeout(timeoutId);
    });
})();